import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "./api";

type JwtPayload = {
  exp?: number;
  email?: string;
};

function safeDecodeJwt(token: string): JwtPayload | undefined {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return undefined;
  }
}

function isExpired(payload: JwtPayload | undefined): boolean {
  if (!payload?.exp) return true;
  return payload.exp * 1000 <= Date.now();
}

function App() {
  const [jwt, setJwt] = useState<string | undefined>(() => localStorage.getItem("jwt") || undefined);
  const [username, setUsername] = useState<string>("");
  const [newUsername, setNewUsername] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);

  const jwtPayload = useMemo(() => (jwt ? safeDecodeJwt(jwt) : undefined), [jwt]);
  const email = jwtPayload?.email ?? "";
  const isLoggedIn = jwt && !isExpired(jwtPayload);

  useEffect(() => {
    if (isLoggedIn) {
      api.getUsername({}).then((res) => setUsername(res.username));
    }
  }, [isLoggedIn]);

  const logout = useCallback(() => {
    localStorage.removeItem("jwt");
    setJwt(undefined);
    setUsername("");
  }, []);

  const handleUpdateUsername = async () => {
    if (newUsername.length < 4 || newUsername.length > 128) {
      alert("Username must be between 4 and 128 characters");
      return;
    }

    try {
      const res = await api.putUsername({ username: newUsername });
      setUsername(res.username);
      setNewUsername("");
      setIsEditing(false);
    } catch (error) {
      alert("Failed to update username");
    }
  };

  return (
    <>
      <h1>Craftdig</h1>

      {!isLoggedIn ? (
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            const token = credentialResponse.credential;
            if (!token) return;

            localStorage.setItem("jwt", token);
            setJwt(token);
          }}
        />
      ) : (
        <>
          <p>
            <h3>Logged in as {email}</h3>
            <button onClick={logout}>Logout</button>
          </p>

          <p>
            <h3>Username: {username}</h3>
            {!isEditing ? (
              <button onClick={() => setIsEditing(true)}>Change Username</button>
            ) : (
              <div>
                <input
                  type="text"
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                  placeholder="Enter new username"
                  minLength={4}
                  maxLength={128}
                />
                <button onClick={handleUpdateUsername}>Save</button>
                <button
                  onClick={() => {
                    setIsEditing(false);
                    setNewUsername("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </p>
        </>
      )}
    </>
  );
}

export default App;
